/**
 * @voltxampere/ui — 16 MHz quartz crystal (Sprint 45-6, placeholder)
 *
 * PLACEHOLDER. LC tank model layer composition — şu anki stamp
 * `inductor` üzerinden tek-element gösterir; gerçek frequency
 * stability + temperature drift + load capacitance Sprint 47+
 * engine extension #4 ile (crystal stamp).
 *
 * Reference: Generic 16 MHz quartz crystal — HC-49S package, ±20 ppm
 * tolerance, ±50 ppm temp drift (-10 to +60°C), C_L = 18 pF.
 * Arduino UNO ATmega328P clock, USB Full-Speed timing reference,
 * RS-232 baud rate generator.
 *
 *   Default mapping → inductor schemaType:
 *     inductance = 1e-3  (1 mH placeholder, gerçek LC tank Sprint 47+)
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const crystal16mhz = {
    id: "crystal-16mhz",
    nameTr: "Kristal 16 MHz (HC-49S, placeholder)",
    nameEn: "Crystal 16 MHz (HC-49S, placeholder)",
    shortcut: "L",
    category: "passive",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "Y",
    defaultValue: "16MHz",
    schemaType: "inductor",
    defaultParams: { inductance: 1e-3 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=crystal-16mhz.js.map